import React, { useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import {
	login,
	setLoginModal,
	setRegistrationModal,
} from "../../redux/reducers";

import styles from "./index.module.scss";
import { PatternFormat } from "react-number-format";

const LoginModal = () => {
	const dispatch = useAppDispatch();

	const [user, setUser] = useState<any>({
		password: "",
		phoneNumber: "",
	});

	const submit = () => {
		dispatch(login({
			password: user.password,
			phoneNumber: user.phoneNumber.replace(/\s/g, "")
		}));
	};
	return (
		<div className={styles.root}>
			<div
				className={styles.background}
				onClick={() => dispatch(setLoginModal())}
			></div>
			<form action="" className="form">
				<div className="title">Вход в учетную запись</div>
				<PatternFormat
					required
					format="+### ## ### ## ##"
					allowEmptyFormatting
					mask="_"
					value={user.phoneNumber}
					onChange={(e:any) => setUser({ ...user, phoneNumber: e.target.value })}
				/>
				<input
					required
					placeholder="Пароль"
					type="password"
					value={user.password}
					onChange={(e:any) => setUser({ ...user, password: e.target.value })}
				/>

				<h3 className={styles.submit} onClick={submit}>
					Войти в аккаунт
				</h3>

				<p>
					Если вы еще не регистрировались, то{" "}
					<span
						onClick={() => {
							dispatch(setRegistrationModal());
							dispatch(setLoginModal());
						}}
					>
						Регистрация
					</span>
				</p>
				<div onClick={() => dispatch(setLoginModal())} className={styles.close}>
					<button type="reset">
						<i className="fa-solid fa-xmark"></i>
					</button>
				</div>
			</form>
		</div>
	);
};

export default LoginModal;
